<template>
  <div>
    <h4 class="font-bold mt-3">Terms and conditions</h4>
    <p class="my-5">
      By clicking ‘Book now’, you are confirming that you have read, understood
      and accepted our
      <span class="hover:underline text-footerColor cursor-pointer">Terms of service</span>
      and the
      <span class="hover:underline text-footerColor cursor-pointer" @click="isParadiseTerms = true">Hawk rental
        terms</span>.
    </p>
    <vs-popup class="holamundo" title="More information" :active.sync="isParadiseTerms">
      <!-- Drop Down from here  -->
      <vs-collapse accordion type="border" class="w-full my-8">
        <vs-collapse-item>
          <div slot="header">Important info</div>
          <section class="w-full flex">
            <!-- left section  -->
            <div class="w-5/12">
              <div class="w-full flex">
                <div>
                  <!-- person icon  -->
                  <svg viewBox="0 0 24 24" class="w-6 h-6 m-6">
                    <path
                      d="M16.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zM18 6A6 6 0 1 0 6 6a6 6 0 0 0 12 0zM3 23.25a9 9 0 1 1 18 0 .75.75 0 0 0 1.5 0c0-5.799-4.701-10.5-10.5-10.5S1.5 17.451 1.5 23.25a.75.75 0 0 0 1.5 0z">
                    </path>
                  </svg>
                </div>
                <div class="flex flex-col justify-center w-full">
                  <div class="font-bold text-black">Driver & licence</div>
                  <div>requirements</div>
                </div>
              </div>
            </div>
            <!-- right section  -->
            <div class="w-7/12">
              <div>When you pick the car up, you'll need:</div>
              <div class="flex items-center">
                <svg fill="#089108" class="w-5 h-5 mr-2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 191.667 191.667" xml:space="preserve"
                  stroke="#089108">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M95.833,0C42.991,0,0,42.99,0,95.833s42.991,95.834,95.833,95.834s95.833-42.991,95.833-95.834S148.676,0,95.833,0z M150.862,79.646l-60.207,60.207c-2.56,2.56-5.963,3.969-9.583,3.969c-3.62,0-7.023-1.409-9.583-3.969l-30.685-30.685 c-2.56-2.56-3.97-5.963-3.97-9.583c0-3.621,1.41-7.024,3.97-9.584c2.559-2.56,5.962-3.97,9.583-3.97c3.62,0,7.024,1.41,9.583,3.971 l21.101,21.1l50.623-50.623c2.56-2.56,5.963-3.969,9.583-3.969c3.62,0,7.023,1.409,9.583,3.969 C156.146,65.765,156.146,74.362,150.862,79.646z">
                    </path>
                  </g>
                </svg>

                <span class="">Passport or national ID card</span>
              </div>
              <div class="flex items-center">
                <svg fill="#089108" class="w-5 h-5 mr-2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 191.667 191.667" xml:space="preserve"
                  stroke="#089108">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M95.833,0C42.991,0,0,42.99,0,95.833s42.991,95.834,95.833,95.834s95.833-42.991,95.833-95.834S148.676,0,95.833,0z M150.862,79.646l-60.207,60.207c-2.56,2.56-5.963,3.969-9.583,3.969c-3.62,0-7.023-1.409-9.583-3.969l-30.685-30.685 c-2.56-2.56-3.97-5.963-3.97-9.583c0-3.621,1.41-7.024,3.97-9.584c2.559-2.56,5.962-3.97,9.583-3.97c3.62,0,7.024,1.41,9.583,3.971 l21.101,21.1l50.623-50.623c2.56-2.56,5.963-3.969,9.583-3.969c3.62,0,7.023,1.409,9.583,3.969 C156.146,65.765,156.146,74.362,150.862,79.646z">
                    </path>
                  </g>
                </svg>

                <span class="">Driving licence</span>
              </div>
              <div class="flex items-center">
                <svg fill="#089108" class="w-5 h-5 mr-2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 191.667 191.667" xml:space="preserve"
                  stroke="#089108">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M95.833,0C42.991,0,0,42.99,0,95.833s42.991,95.834,95.833,95.834s95.833-42.991,95.833-95.834S148.676,0,95.833,0z M150.862,79.646l-60.207,60.207c-2.56,2.56-5.963,3.969-9.583,3.969c-3.62,0-7.023-1.409-9.583-3.969l-30.685-30.685 c-2.56-2.56-3.97-5.963-3.97-9.583c0-3.621,1.41-7.024,3.97-9.584c2.559-2.56,5.962-3.97,9.583-3.97c3.62,0,7.024,1.41,9.583,3.971 l21.101,21.1l50.623-50.623c2.56-2.56,5.963-3.969,9.583-3.969c3.62,0,7.023,1.409,9.583,3.969 C156.146,65.765,156.146,74.362,150.862,79.646z">
                    </path>
                  </g>
                </svg>

                <span class="">Credit card</span>
              </div>
            </div>
          </section>
          <vs-divider />
          <section class="w-full flex">
            <!-- left section  -->
            <div class="w-5/12">
              <div class="w-full flex">
                <div>
                  <!-- gas station icon  -->
                  <svg viewBox="0 0 24 24" class="w-6 h-6 m-6" height="1em">
                    <path
                      d="M15 12v10.25a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V1.75a.25.25 0 0 1 .25-.25h13a.25.25 0 0 1 .25.25V12zm1.5 0V1.75A1.75 1.75 0 0 0 14.75 0h-13A1.75 1.75 0 0 0 0 1.75v20.5C0 23.216.784 24 1.75 24h13a1.75 1.75 0 0 0 1.75-1.75V12zm-3-6.75A2.25 2.25 0 0 0 11.25 3h-6a2.25 2.25 0 0 0 0 4.5h6a2.25 2.25 0 0 0 2.25-2.25zm-1.5 0a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75zM.75 10.5h15a.75.75 0 0 0 0-1.5h-15a.75.75 0 0 0 0 1.5zm15-4.5h1.5a.75.75 0 0 1 .75.75v15a2.25 2.25 0 0 0 4.5 0v-9c0-.83.246-1.643.706-2.334l.668-1a.75.75 0 0 0-1.248-.833l-.668 1A5.71 5.71 0 0 0 21 12.75v9a.75.75 0 0 1-1.5 0v-15a2.25 2.25 0 0 0-2.25-2.25h-1.5a.75.75 0 0 0 0 1.5zm6 7.5h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5z">
                    </path>
                  </svg>
                </div>
                <div class="flex flex-col justify-center w-full">
                  <div class="font-bold text-black">Fuel Policy</div>
                  <div>Like for like</div>
                </div>
              </div>
            </div>
            <!-- right section  -->
            <div class="w-7/12">
              <div>
                When you pick your car up, the fuel tank will be full or partly
                full. You will leave a deposit to cover the cost of the fuel:
                the counter staff will block this money on your credit card.
                Just before you return your car, please replace the fuel you've
                used.
              </div>
            </div>
          </section>
          <vs-divider />
          <section class="w-full flex">
            <!-- left section  -->
            <div class="w-5/12">
              <div class="w-full flex">
                <div>
                  <!-- gas station icon  -->
                  <svg viewBox="0 0 24 24" class="w-6 h-6 m-6" height="1em">
                    <path
                      d="M15 12v10.25a.25.25 0 0 1-.25.25h-13a.25.25 0 0 1-.25-.25V1.75a.25.25 0 0 1 .25-.25h13a.25.25 0 0 1 .25.25V12zm1.5 0V1.75A1.75 1.75 0 0 0 14.75 0h-13A1.75 1.75 0 0 0 0 1.75v20.5C0 23.216.784 24 1.75 24h13a1.75 1.75 0 0 0 1.75-1.75V12zm-3-6.75A2.25 2.25 0 0 0 11.25 3h-6a2.25 2.25 0 0 0 0 4.5h6a2.25 2.25 0 0 0 2.25-2.25zm-1.5 0a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75zM.75 10.5h15a.75.75 0 0 0 0-1.5h-15a.75.75 0 0 0 0 1.5zm15-4.5h1.5a.75.75 0 0 1 .75.75v15a2.25 2.25 0 0 0 4.5 0v-9c0-.83.246-1.643.706-2.334l.668-1a.75.75 0 0 0-1.248-.833l-.668 1A5.71 5.71 0 0 0 21 12.75v9a.75.75 0 0 1-1.5 0v-15a2.25 2.25 0 0 0-2.25-2.25h-1.5a.75.75 0 0 0 0 1.5zm6 7.5h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5z">
                    </path>
                  </svg>
                </div>
                <div class="flex flex-col justify-center w-full">
                  <div class="font-bold text-black">Mileage</div>
                  <div>Unlimited</div>
                </div>
              </div>
            </div>
            <!-- right section  -->
            <div class="w-7/12">
              <div>Your rental includes unlimited free kilometres.</div>
            </div>
          </section>
          <vs-divider />
          <section>
            <div class="text-black font-sans text-sm text-justify">
              Please see the Service Provider’s full terms and conditions below,
              which include the full name and company registered address of your
              Service Provider, information on and fees of extra products and
              services purchasable at the counter or based on your use of the
              rental, such as driving cross border and, if any, pick-up and
              drop-off grace periods.
            </div>
          </section>
        </vs-collapse-item>

        <vs-collapse-item>
          <div slot="header">Full rental terms</div>
          <fullRentalTermsDropDown />
        </vs-collapse-item>
      </vs-collapse>
    </vs-popup>
  </div>
</template>

<script>
import fullRentalTermsDropDown from "./fullRentalTermsDropDown.vue";
export default {
  data() {
    return {
      isParadiseTerms: false,
    };
  },
  components: { fullRentalTermsDropDown },
  methods: {},
  created() { },
  mounted() { },
};
</script>

<style scoped></style>
